import AbstractPicker, { getDefaultProps } from './AbstractPicker';
import popupProps from './popupProps';
export default class Picker extends AbstractPicker {
    constructor() {
        super(...arguments);
        this.popupProps = popupProps;
    }
}
Picker.defaultProps = getDefaultProps();



// WEBPACK FOOTER //
// ./components/picker/index.tsx